import type { BadgeTone } from '@/app/components/ui/Badge';
import type { CommunicationStatus } from '@/features/communications/types';

/** `verzonden` is the "done" outcome — mint, same "no separate success tone"
 * spirit as `pilots/statusTone.ts`. `concept`/`ingepland` are neutral. */
export function statusTone(status: CommunicationStatus): BadgeTone {
  if (status === 'verzonden') return 'mint';
  return 'outline';
}
